export default "__VITE_ASSET__DLul5liY__"